// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__qPKrx","header":"ReportDetails_header__3Zmxt","title":"ReportDetails_title__1CzGX","left":"ReportDetails_left__3Fdky"};